module.exports = __webpack_public_path__ + "img/sns_facebook.306de555.svg";